var React = require('react');

function Repo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.5 4h-.5v-3.5c0-.276-.224-.5-.5-.5h-14c-1.379 0-2.5 1.122-2.5 2.5v19c0 1.378 1.121 2.5 2.5 2.5h15c.276 0 .5-.224.5-.5v-19c0-.276-.224-.5-.5-.5zm-15-3h13.5v3h-1v-.5c0-.276-.224-.5-.5-.5h-6c-.276 0-.5.224-.5.5v.5h-5.5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5zm6.5 3h5v10.293l-2.146-2.147c-.098-.097-.226-.146-.354-.146s-.256.049-.354.146l-2.146 2.147v-10.293zm8 19h-14.5c-.827 0-1.5-.673-1.5-1.5v-17.013c.419.318.935.513 1.5.513h5.5v10.5c0 .202.122.385.309.462.185.078.401.035.545-.108l2.646-2.647 2.646 2.647c.096.095.224.146.354.146l.191-.038c.187-.077.309-.26.309-.462v-10.5h2v18z"}));
}

Repo.defaultProps = {"version":"1","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Repo;

Repo.default = Repo;
